export default __webpack_public_path__ + "media/images/academy-mascot-f2a87881554bb33a2b65165c26f757fd.webp";